import { Layout as _Layout } from './layout';
import { LayoutAside } from './layout-aside';
import { LayoutMain } from './layout-main';
import { LayoutContent } from './layout-content';
import { LayoutNav, NavItem } from './layout-nav';
const Layout = _Layout;
Layout.Aside = LayoutAside;
Layout.Main = LayoutMain;
Layout.Content = LayoutContent;
Layout.Nav = LayoutNav;
Layout.NavItem = NavItem;
export default Layout;
